import depo from './services/depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import { createWebHistory, createRouter } from "vue-router";
import AdminLayout from "./components/Layouts/AdminLayout.vue";
import AuthLayout from "./components/Layouts/AuthLayout.vue";
import SistemLayout from "./components/Layouts/SistemLayout.vue";
import store from './store/index.js';


const routes = [
    {
        path: "",
        redirect: "/auth/login"
    },
    // {
    //     path: "/anasayfa",
    //     beforeEnter(to, from, next) {
    //         window.location.replace("https://www.HepyApp.com")
    //     }
    // },
    // Blog — eski önek /blog_ idi (projede tek alt çizgili rota). WebSayfa kayıtları
    // DDL-Faz-1-Sema.sql ile /blog/... olarak taşındı; eski URL'ler yönlendirmeyle korunuyor.
    { path: "/blog", redirect: "/blog/yazilar" },
    { path: "/blog_", redirect: "/blog/yazilar" },
    { path: "/blog_/tumyazilar", redirect: "/blog/yazilar" },
    { path: "/blog_/yeniyazi", redirect: "/blog/yeniyazi" },
    {
        path: "/blog",
        name: "",
        component: AdminLayout,
        meta: { title: 'Blog' },
        children: [{
            path: "/blog/yazilar",
            name: "Blog_",
            meta: { title: 'Blog Yazıları' },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/BlogListesi.vue")
        },
        {
            // Yeni ve düzenle AYNI bileşen (TarifForm.vue deseni) — isEdit route param'ından türer
            path: "/blog/yeniyazi",
            name: "Blog_YeniYazi",
            meta: { title: 'Yeni Blog Yazısı', ust: "/blog/yazilar", mobil: 'masaustu' },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/BlogYaziForm.vue")
        },
        {
            path: "/blog/duzenle/:id",
            name: "Blog_DuzenleYazi",
            meta: { title: 'Blog Yazısı Düzenle', ust: "/blog/yazilar", mobil: 'masaustu' },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/BlogYaziForm.vue")
        },
        {
            path: "/blog/kategoriler",
            name: "Blog_Kategoriler",
            meta: { title: 'Blog Kategorileri' },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/Kategoriler.vue")
        },
        {
            path: "/blog/koleksiyonlar",
            name: "Blog_Koleksiyonlar",
            meta: { title: 'Blog Koleksiyonları' },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/Koleksiyonlar.vue")
        },
        {
            path: "/blog/koleksiyon/:id",
            name: "Blog_KoleksiyonDetay",
            meta: { title: 'Koleksiyon Detay', ust: "/blog/koleksiyonlar" },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/KoleksiyonDetay.vue")
        },
        {
            path: "/blog/rapor",
            name: "Blog_Rapor",
            meta: { title: 'Blog Raporu' },
            component: () =>
                import("./components/HepyApp/PrivatePage/Blog/BlogRapor.vue")
        },

        ]
    },

    { path: "/auth", redirect: "/auth/login" },
    {
        path: "/auth",
        name: "",
        component: AuthLayout,
        meta: { title: 'Giriş' },
        children: [{
            path: "/auth/login",
            name: "Login",
            component: () =>
                import("./components/HepyApp/PublicPage/Auth/Login.vue"),
        }
        ]
    },
    { path: "/sifreislemleri", redirect: "/sifreislemleri/sifreunuttum" },
    {
        path: "/sifreislemleri/sifreyenile/:id",
        name: "",
        component: AuthLayout,
        meta: { title: 'Şifre Unuttum' },
        children: [
            {
                path: "/sifreislemleri/sifreunuttum",
                name: "SifreUnuttum",
                meta: { title: 'Şifremi Unuttum' },
                component: () =>
                    import("./components/HepyApp/PublicPage/SifreIslemleri/SifreUnuttum.vue")
            },
            {
                path: "/sifreislemleri/sifreyenile",
                name: "SifreYenile",
                meta: { title: 'Şifre Yenile' },
                component: () =>
                    import("./components/HepyApp/PublicPage/SifreIslemleri/SifreYenile.vue")
            }
        ]
    },

    { path: "/admin", redirect: "/admin/main" },
    {
        path: "/admin",
        meta: { title: 'Anasayfa' },
        name: "",
        component: AdminLayout,
        children: [{
            path: "/admin/main",
            name: "Main",
            meta: { baslik: false },
            component: () =>
                import("./components/HepyApp/PrivatePage/AdminSayfalari/AdminSayfasi.vue")
        },
        ]
    },
    { path: "/kullanici", redirect: "/kullanici/ayarlar" },
    {
        path: "/kullanici",
        name: "",
        component: AdminLayout,
        meta: { title: 'Kullanıcı' },
        children: [{
            path: "/kullanici/ayarlar",
            name: "Kullanici",
            meta: { title: 'Kullanıcı Ayarları' },
            component: () =>
                import("./components/HepyApp/PrivatePage/KullaniciAyarlari/Ayarlar.vue")
        },
        ]
    },
    // Faz 7 temizligi: eski /yonetim/* sayfalari Sistem Konsolu'na (Faz 6) tasindi,
    // bilesenler + component import'lari kaldirildi, yalniz eski yer imleri icin redirect kaldi.
    { path: "/yonetim", redirect: "/sistem/genel" },
    { path: "/yonetim/servis-log", redirect: "/sistem/servis-log" },
    { path: "/yonetim/joblistesi", redirect: "/sistem/joblar" },
    { path: "/yonetim/sistemdurum", redirect: "/sistem/durum" },
    { path: "/yonetim/hatakural", redirect: "/sistem/ayarlar/hatakural" },
    { path: "/yonetim/sparqonayar", redirect: "/sistem/sparqon/ayar" },
    { path: "/yonetim/sparqonlog", redirect: "/sistem/sparqon/log" },
    { path: "/yonetim/sparqonyetenek", redirect: "/sistem/sparqon/yetenek" },
    { path: "/yonetim/disbesinkatalogu", redirect: "/sistem/ayarlar/besinkatalogu" },
    { path: "/yonetim/entegrasyonayarlari", redirect: "/sistem/entegrasyonlar" },
    { path: "/yonetim/demotalepleri", redirect: "/sistem/sirketler/demo-talepler" },
    { path: "/yonetim/demotalepdetay", redirect: "/sistem/sirketler/demo-talepler/detay" },
    { path: "/yonetim/mailsablon", redirect: "/sistem/ayarlar/mailsablon" },
    { path: "/yonetim/sqlolaylogu", redirect: "/sistem/sql-olay" },
    { path: "/yonetim/rolyetki", redirect: "/sistem/yetki/rolyetki" },
    { path: "/yonetim/yetki", redirect: "/sistem/yetki/yetkiyeri" },
    { path: "/yonetim/websayfa", redirect: "/sistem/yetki/websayfa" },
    { path: "/yonetim/sistem/tabloboyut", redirect: "/sistem/ayarlar/tabloboyut" },
    { path: "/musteri", redirect: "/musteri/musterilistesi" },
    {
        path: "/musteri/:MusteriNo",
        name: "",
        component: AdminLayout,
        meta: { title: 'Müşteri' },
        children: [
            {
                path: "/musteri/musterilistesi",
                name: "MusteriListesi",
                meta: { title: 'Müşteriler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Musteri/MusteriListesi.vue")
            },
            {
                path: "/musteri/yenimusteri",
                name: "MusteriTanimla",
                meta: { title: 'Yeni Müşteri', ust: "/musteri/musterilistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Musteri/YeniMusteri.vue")
            },
            {
                path: "/musteri/duzenlemusteri",
                name: "DuzenleMusteri2",
                meta: { title: 'Müşteri Düzenle', ust: "/musteri/musterilistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Musteri/DuzenleMusteri.vue")
            },
            {
                path: "/musteri/borclumusteri",
                name: "Borçlu Müşteri",
                meta: { title: 'Müşteri Hesap', ust: "/musteri/musterilistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Musteri/BorcluMusteri.vue")
            },
            {
                path: "/musteri/potansiyelmusteri",
                name: "PotansiyelMüşteri",
                meta: { title: 'Potansiyel Müşteri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Musteri/PotansiyelMusteri.vue")
            },
            {
                path: "/musteri/onkayitform",
                name: "OnKayitForm2",
                meta: { title: 'Ön Kayıt' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Musteri/OnKayitForm.vue")
            },
        ]
    },
    { path: "/talep-teklif-siparis", redirect: "/talep-teklif-siparis/dashboard" },
    {
        path: "/talep-teklif-siparis/dashboard",
        name: "",
        component: AdminLayout,
        meta: { title: 'Talep Teklif Siparis' },
        children: [
            {
                path: "/talep-teklif-siparis/dashboard",
                name: "TalepTeklifSiparisDashboard",
                meta: { title: 'Talep / Teklif / Sipariş Panosu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Dashboard.vue")
            },
            {
                path: "/talep-teklif-siparis/taleplistesi",
                name: "TalepListesi",
                meta: { title: 'Talep Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Talep/TalepListesi.vue")
            },
            {
                path: "/talep-teklif-siparis/siparislistesi",
                name: "SiparisListesi",
                meta: { title: 'Sipariş Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Siparis/SiparisListesi.vue")
            },
            {
                path: "/talep-teklif-siparis/siparisdetay",
                name: "SiparisDetay",
                meta: { title: 'Sipariş Detayı', ust: "/talep-teklif-siparis/siparislistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Siparis/DetaySiparis.vue")
            },
            {
                path: "/talep-teklif-siparis/tutarsizlik",
                name: "TTSTutarsizlik",
                meta: { title: 'Hatalı / Tutarsız Kayıtlar', icerikGenisligi: 'max-w-5xl' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/TutarsizlikRaporu.vue")
            },
        ]
    },
    {
        path: "/teklif",
        name: "Teklif",
        component: AdminLayout,
        meta: { title: 'Teklif' },
        children: [
            {
                path: "/teklif/teklifdetay",
                name: "TeklifDetay",
                meta: { title: 'Teklif Detayı', ust: "/teklif/tekliflistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/DetayTeklif.vue")
            },
            {
                path: "/teklif/tekliflistesi",
                name: "TeklifListesi",
                meta: { title: 'Teklifler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/TeklifListesi.vue")
            },
            {
                path: "/teklif/teklifolustur",
                name: "TeklifOlustur",
                meta: { title: 'Yeni Teklif', ust: "/teklif/tekliflistesi", mobil: 'masaustu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/TeklifOlustur.vue")
            },
            {
                path: "/teklif/teklifpdf",
                name: "TeklifPDF",
                meta: { title: 'Teklif PDF', ust: "/teklif/tekliflistesi", mobil: 'masaustu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/TeklifPDF.vue")
            },
            {
                path: "/teklif/sablonlistesi",
                name: "SablonListesi",
                meta: { title: 'Teklif Şablonları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/Sablon/SablonListesi.vue")
            },
            {
                path: "/teklif/detaysablon",
                name: "DetaySablon",
                meta: { title: 'Teklif Şablonu - Detay', ust: "/teklif/sablonlistesi", mobil: 'masaustu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/Sablon/DetaySablon.vue")
            },
            {
                path: "/teklif/onaykuyrugu",
                name: "OnayKuyrugu",
                meta: { title: 'Onay Kuyruğu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/OnayKuyrugu.vue")
            },
            {
                path: "/teklif/revizyon",
                name: "RevizyonKarsilastir",
                meta: {
                    title: 'Revizyon Karşılaştır',
                    mobil: 'masaustu',
                    ust: (r) => r.query.pTeklif
                        ? { path: "/teklif/teklifdetay", query: { TeklifNo: r.query.pTeklif } }
                        : null
                },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/RevizyonKarsilastir.vue")
            },
            {
                path: "/teklif/gonderimmerkezi",
                name: "GonderimMerkezi",
                meta: { title: 'Gönderim Merkezi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/GonderimMerkezi.vue")
            },
            {
                path: "/teklif/kampanyalistesi",
                name: "KampanyaListesi",
                meta: { title: 'Kampanyalar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/KampanyaListesi.vue")
            },
            {
                path: "/teklif/raporlar",
                name: "TeklifRaporlar",
                meta: { title: 'Teklif Raporları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/TeklifRaporlar.vue")
            },
            {
                path: "/teklif/aylikteklif",
                name: "AylikTeklifTrend",
                meta: { title: 'Aylık Teklif Trendi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/AylikTeklifTrend.vue")
            },
            {
                path: "/teklif/musteriteklif",
                name: "MusteriTeklif",
                meta: { title: 'Müşteri Bazlı Teklif' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/MusteriTeklif.vue")
            },
            {
                path: "/teklif/temsilciperformans",
                name: "TemsilciPerformans",
                meta: { title: 'Temsilci Performansı' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/TemsilciPerformans.vue")
            },
            {
                path: "/teklif/siparisdonusum",
                name: "SiparisDonusum",
                meta: { title: 'Teklif → Sipariş Dönüşüm' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/SiparisDonusum.vue")
            },
            {
                path: "/teklif/parametreler",
                name: "TeklifParametreler",
                meta: { title: 'Teklif Parametreleri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/TalepTeklifSiparis/Teklif/Parametreler.vue")
            },
        ]
    },

    { path: "/sirket", redirect: "/sistem/sirketler" },
    // Eski şirket sayfası URL'leri → birleşik sayfa (SirketKayit). Statik path'ler
    // "/sirket/:SirketNo" dinamik eşleşmesinden önce değerlendirilir.
    { path: "/sirket/yenisirket", redirect: "/sirket/sirketkayit" },
    {
        path: "/sirket/duzenlesirket",
        redirect: (to) => {
            // Eski sekme index'lerini (?tab=0..7) yeni bölüm anahtarlarına çevir
            const eskiTab = { "0": "genel", "1": "sube", "2": "rol", "3": "kullanici", "4": "diger", "5": "lisans", "6": "baglantilar", "7": "ai" };
            const q = { ...to.query };
            if (q.tab !== undefined) {
                q.bolum = eskiTab[String(q.tab)] || "genel";
                delete q.tab;
            }
            return { path: "/sirket/sirketkayit", query: q };
        },
    },
    {
        path: "/sirket/:SirketNo",
        name: "",
        component: AdminLayout,
        meta: { title: 'Şirket' },
        children: [
            {
                // Faz 6 #15 (SistemSirketListesi'ne tasindi) + Faz 7: eski bilesen kaldirildi.
                path: "/sirket/sirketlistesi",
                redirect: "/sistem/sirketler"
            },
            {
                path: "/sirket/sirketkayit",
                name: "SirketKayit",
                meta: { title: 'Şirket Kayıt', ust: "/sistem/sirketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Sirket/SirketKayit.vue")
            },
            {
                // Faz 6 #25 (SistemSirketSihirbazi'na tasindi) + Faz 7: eski bilesen kaldirildi.
                // Not: bu rotanin kendi WebSayfa kaydi yoktu (/sirket/sirketkayit'ten onek mirasiydi),
                // bu yuzden DDL'de silinecek ayri bir satir cikmiyor.
                path: "/sirket/sirketkayit/sihirbaz",
                redirect: "/sistem/sirketler/yeni"
            },
            //
            {
                path: "/sirket/sube/subelistesi",
                name: "SubeListesi",
                meta: { title: 'Şube Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Sirket/Sube/SubeListesi.vue")
            },
            {
                path: "/sirket/sube/yenisube",
                name: "SubeTanimla",
                meta: {
                    title: 'Yeni Şube',
                    ust: (r) => r.query.SirketNo
                        ? { path: "/sirket/sirketkayit", query: { SirketNo: r.query.SirketNo } }
                        : "/sirket/sirketlistesi"
                },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Sirket/Sube/YeniSube.vue")
            },
            {
                path: "/sirket/sube/duzenlesube",
                name: "DuzenleSube",
                meta: { title: 'Şube Düzenle', ust: "/sirket/sirketlistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Sirket/Sube/DuzenleSube.vue")
            },

        ]
    },
    {
        path: "/whatsapp",
        name: "",
        component: AdminLayout,
        meta: { title: 'WhatsApp' },
        children: [
            {
                path: "/whatsapp/numaralar",
                name: "WPEntegrasyonListesi",
                meta: { title: 'WhatsApp Numaraları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPEntegrasyonListesi.vue")
            },
            {
                path: "/whatsapp/kota",
                name: "WPKotaYonetimi",
                meta: { title: 'Mesaj Kota Yönetimi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPKotaYonetimi.vue")
            },
            {
                path: "/whatsapp/loglar",
                name: "WPMesajLog",
                meta: { title: 'WhatsApp Mesaj Logları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPMesajLog.vue")
            },
            {
                path: "/whatsapp/engel",
                name: "WPEngelListesi",
                meta: { title: 'WhatsApp Engel Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPEngelListesi.vue")
            },
            {
                path: "/whatsapp/yasaklikelime",
                name: "WPYasakliKelime",
                meta: { title: 'WhatsApp Yasaklı Kelimeler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPYasakliKelime.vue")
            },
            {
                path: "/whatsapp/sablonlar",
                name: "WPSablonListesi",
                meta: { title: 'WhatsApp Şablonları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPSablonListesi.vue")
            },
            {
                path: "/whatsapp/asistan-ayar",
                name: "WPAsistanAyar",
                meta: { title: 'WhatsApp AI Asistan Ayarları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPAsistanAyar.vue")
            },
        ]
    },
    { path: "/urun", redirect: "/urun/urunlistesi" },
    {
        path: "/urun/:UrunNo",
        name: "",
        component: AdminLayout,
        meta: { title: 'Ürün' },
        children: [
            {
                path: "/urun/urunlistesi",
                name: "UrunListesi",
                meta: { title: 'Ürün Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Tanimlamalar/Urun/UrunListesi.vue")
            },
            {
                path: "/urun/yeniurun",
                name: "UrunYeni",
                meta: { title: 'Yeni Ürün', ust: "/urun/urunlistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Tanimlamalar/Urun/YeniUrun.vue")
            },
            {
                path: "/urun/duzenleurun",
                name: "UrunDuzenle",
                meta: { title: 'Ürün Düzenle', ust: "/urun/urunlistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Tanimlamalar/Urun/DuzenleUrun.vue")
            },

        ]
    },
    { path: "/randevu", redirect: "/randevu/dashboard" },
    {
        path: "/randevu/dashboard",
        name: "",
        component: AdminLayout,
        meta: { title: 'Randevu Sistemi' },
        children: [
            {
                path: "/randevu/dashboard",
                name: "RandevuDashboard",
                meta: { title: 'Randevu Takvimi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Randevu/Dashboard.vue")
            },
            // IBS-2: kiracı kendi işletme + şube bilgileri (WebSayfa /ayarlar/isletme, sahip rol).
            {
                path: "/ayarlar/isletme",
                name: "IsletmeBilgileri",
                meta: { title: 'İşletme Bilgileri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Ayarlar/IsletmeBilgileri.vue")
            },
            {
                path: "/randevu/ayarlar",
                name: "RandevuAyar",
                meta: { title: 'Randevu Ayarları', ust: "/randevu/dashboard" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Randevu/Ayarlar.vue")
            },
            {
                path: "/randevu/raporlar",
                name: "RandevuRaporlar",
                meta: { title: 'Randevu Raporları', ust: "/randevu/dashboard" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Randevu/Raporlar.vue")
            },
        ]
    },
    { path: "/studio", redirect: "/studio/dashboard" },
    {
        path: "/studio/dashboard",
        name: "Studio",
        component: AdminLayout,
        meta: { title: 'Stüdyo' },
        children: [
            {
                path: "/studio/dashboard",
                name: "StudioDashboard",
                meta: { title: 'Stüdyo Takvim', tamYukseklik: true },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/Dashboard.vue")
            },
            {
                path: "/studio/dersyeni",
                name: "StudioDersYeni",
                meta: { title: 'Yeni Ders', ust: "/studio/dashboard", mobil: 'masaustu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/DersYeni.vue")
            },
            {
                path: "/studio/dersduzenle/:id",
                name: "StudioDersDuzenle",
                meta: { title: 'Ders Düzenle', ust: "/studio/dashboard", mobil: 'masaustu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/DersYeni.vue")
            },
            {
                path: "/studio/ayarlar",
                name: "StudioAyarlar",
                meta: { title: 'Stüdyo Ayarları', ust: "/studio/dashboard" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/StudioAyarlar.vue")
            },
            {
                path: "/studio/musteri-paket-listesi",
                name: "StudioMusteriPaketListesi",
                meta: { title: 'Müşteri Paket Detay Raporu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/MusteriPaketListesi.vue")
            },
            {
                path: "/studio/dersdoluluk",
                name: "StudioDersDoluluk",
                meta: { title: 'Ders Doluluk' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/StudioDersDoluluk.vue")
            },
            {
                path: "/studio/egitmenperformans",
                name: "StudioEgitmenPerformans",
                meta: { title: 'Eğitmen Performansı' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/StudioEgitmenPerformans.vue")
            },
            {
                path: "/studio/paketsatis",
                name: "StudioPaketSatis",
                meta: { title: 'Paket Satış' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/StudioPaketSatis.vue")
            },
            {
                path: "/studio/paketdurum",
                name: "StudioPaketDurum",
                meta: { title: 'Paket Durumu / Yenileme' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/StudioPaketDurum.vue")
            },
            {
                path: "/studio/salonkullanim",
                name: "StudioSalonKullanim",
                meta: { title: 'Salon Kullanımı' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Studio/StudioSalonKullanim.vue")
            },
        ]
    },
    { path: "/kasa", redirect: "/kasa/dashboard" },
    {
        path: "/dashboard",
        name: "",
        component: AdminLayout,
        meta: { title: 'Kasa' },
        children: [
            {
                path: "/kasa/dashboard",
                name: "Dashboard",
                meta: { title: 'Kasa Panosu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/KasaDashboard.vue")
            },
            {
                path: "/kasa/urunkarzarar",
                name: "Ürün Kar Zarar",
                meta: { title: 'Kâr-Zarar Raporu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/UrunKarZarar.vue")
            },
            {
                path: "/kasa/toplammaliyet",
                name: "ToplamMaliyet",
                meta: { title: 'Toplam Maliyet' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/ToplamMaliyet.vue")
            },
            {
                path: "/kasa/satisdokumu",
                name: "SatisDokumu",
                meta: { title: 'Satış Dökümü' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/SatisDokumu.vue")
            },
            {
                path: "/kasa/cirotrend",
                name: "CiroTrend",
                meta: { title: 'Ciro Trendi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/CiroTrend.vue")
            },
            {
                path: "/kasa/urunkarlilik",
                name: "UrunKarlilik",
                meta: { title: 'Ürün Kârlılık' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/UrunKarlilik.vue")
            },
            {
                path: "/kasa/tahsilatcari",
                name: "TahsilatCari",
                meta: { title: 'Tahsilat & Cari' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/TahsilatCari.vue")
            },
            {
                path: "/kasa/subekarsilastirma",
                name: "SubeKarsilastirma",
                meta: { title: 'Şube Karşılaştırma' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/SubeKarsilastirma.vue")
            },
            {
                path: "/kasa/urungirismaliyet",
                name: "UrunGirisMaliyet",
                meta: { title: 'Ürün Giriş / Maliyet' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/UrunGirisMaliyet.vue")
            },
            {
                path: "/kasa/iptaliade",
                name: "IptalIade",
                meta: { title: 'İptal / İade' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/IptalIade.vue")
            },
            {
                path: "/kasa/avansraporu",
                name: "AvansRaporu",
                meta: { title: 'Avans / Müşteri Alacağı' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/AvansRaporu.vue")
            },
            {
                path: "/kasa/riskraporu",
                name: "RiskRaporu",
                meta: { title: 'Risk / Kredi Limiti' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/RiskRaporu.vue")
            },
            {
                path: "/kasa/yaslandirma",
                name: "Yaslandirma",
                meta: { title: 'Yaşlandırma (Aging)' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/Yaslandirma.vue")
            },
            {
                path: "/kasa/cariekstre",
                name: "CariEkstre",
                meta: { title: 'Cari Ekstre' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/CariEkstre.vue")
            },
            {
                path: "/kasa/tahsilatperformans",
                name: "TahsilatPerformans",
                meta: { title: 'Tahsilat Performansı' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/TahsilatPerformans.vue")
            },
            {
                path: "/kasa/bildirimlog",
                name: "BildirimLog",
                meta: { title: 'Bildirim Günlüğü' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/BildirimLog.vue")
            },
            {
                path: "/kasa/bildirimayar",
                name: "BildirimAyar",
                meta: { title: 'Bildirim Ayarları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/BildirimAyar.vue")
            },
            {
                path: "/kasa/kdvraporu",
                name: "KdvRaporu",
                meta: { title: 'KDV Raporu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Kasa/KdvRaporu.vue")
            },
        ]
    },
    // Satis
    { path: "/islemler", redirect: "/islemler/giris" },
    {
        path: "/islemler/:pMusteri",
        name: "İşlemler",
        component: AdminLayout,
        meta: { title: 'İşlemler' },
        children: [
            {
                path: "/islemler/giris",
                name: "Giris",
                meta: { title: 'Ürün Giriş' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/Giris.vue")
            },
            {
                path: "/islemler/satis",
                name: "Satis",
                meta: { title: 'Ürün Satış' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/Satis.vue")
            },
            {
                path: "/islemler/satisiptal",
                name: "SatisIptal",
                meta: { title: 'Satış İptal' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/SatisIptal.vue")
            },
            {
                path: "/islemler/odemeal",
                name: "OdemeAl",
                meta: { title: 'Ödeme Al', ust: "/musteri/borclumusteri" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/OdemeAl.vue")
            },

            {
                path: "/islemler/stokdashboard",
                name: "StokDashboard",
                meta: { title: 'Stok Panosu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/Stok/StokDashboard.vue")
            },
            {
                path: "/islemler/stok/stoklimitlistesi",
                name: "StokLimitListesi",
                meta: { title: 'Stok Limitleri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/Stok/StokLimit/StokLimitListesi.vue")
            },
            {
                path: "/islemler/stok/yenistoklimit",
                name: "YeniStokLimit",
                meta: { title: 'Yeni Stok Limit', ust: "/islemler/stok/stoklimitlistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/Stok/StokLimit/YeniStokLimit.vue")
            },
            {
                path: "/islemler/stok/duzenlestoklimit",
                name: "DuzenleStokLimit",
                meta: { title: 'Stok Limit Düzenle', ust: "/islemler/stok/stoklimitlistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Islemler/Stok/StokLimit/DuzenleStokLimit.vue")
            },
        ]
    },
    // ── Diyetisyen ──────────────────────────────────────────────────────────
    // Modulun TEK giris noktasi: /diyetisyen/calisma (danisan rayi + plan + araclar).
    // Danisan listesi, danisan detayi, yemek, ogun tipi, sablon ve export ARTIK SAYFA DEGIL —
    // hepsi calisma alaninin uzerinde Drawer/Dialog. Buraya yeni route EKLEMEYIN,
    // calisma alanina bir overlay ekleyin; modul tekrar parcalanmasin.
    { path: "/diyetisyen", redirect: "/diyetisyen/calisma" },
    {
        path: "/diyetisyen",
        name: "",
        component: AdminLayout,
        meta: { title: 'Diyetisyen' },
        children: [
            {
                path: "/diyetisyen/calisma",
                name: "DiyetisyenCalismaAlani",
                meta: { title: 'Diyetisyen Çalışma Alanı', mobil: 'masaustu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Diyetisyen/Calisma/CalismaAlani.vue")
            },
            {
                // Eski /diyetisyen/dashboard — pano artik acilis ekrani degil, ozet.
                path: "/diyetisyen/ozet",
                name: "DiyetisyenOzet",
                meta: { title: 'Diyetisyen Panosu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Diyetisyen/Dashboard/Dashboard.vue")
            },
            {
                path: "/diyetisyen/danisangelisim",
                name: "DanisanGelisim",
                meta: { title: 'Danışan Gelişim' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Diyetisyen/Rapor/DanisanGelisim.vue")
            },
            {
                path: "/diyetisyen/danisantrend",
                name: "DanisanTrend",
                meta: { title: 'Yeni Danışan Trendi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Diyetisyen/Rapor/DanisanTrend.vue")
            },
            {
                path: "/diyetisyen/diyeturetim",
                name: "DiyetUretim",
                meta: { title: 'Diyet Üretim' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Diyetisyen/Rapor/DiyetUretim.vue")
            },
            {
                path: "/diyetisyen/olcumtakip",
                name: "OlcumTakip",
                meta: { title: 'Ölçüm Takip' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Diyetisyen/Rapor/OlcumTakip.vue")
            },
        ]
    },
    { path: "/tanimlamalar", redirect: "/tanimlamalar/kategori" },
    {
        path: "/tanimlamalar",
        name: "",
        component: AdminLayout,
        meta: { title: 'Ürünler' },
        children: [
            {
                path: "/tanimlamalar/kategori",
                name: "KategoriTanim",
                meta: { title: 'Kategoriler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Tanimlamalar/Kategori.vue")
            },
            {
                path: "/tanimlamalar/altkategori",
                name: "AltKategoriTanim",
                meta: { title: 'Alt Kategoriler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Tanimlamalar/AltKategori.vue")
            },
            {
                path: "/tanimlamalar/birim",
                name: "BirimTanim",
                meta: { title: 'Birimler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Tanimlamalar/Birim.vue")
            },
        ]
    },
    // Faz 7 temizligi: eski /yardim/* (admin yardim yonetimi) Sistem Konsolu'na (Faz 6 #22-24) tasindi.
    { path: "/yardim", redirect: "/sistem/yardim" },
    { path: "/yardim/yardimlistesi", redirect: "/sistem/yardim" },
    { path: "/yardim/yeniyardim", redirect: "/sistem/yardim/yeni" },
    { path: "/yardim/duzenleyardim", redirect: "/sistem/yardim/duzenle" },
    { path: "/yardim", redirect: "/yardim/genelyardim" },
    {
        path: "/yardim/:SayfaUrl",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/yardim/genelyardimsayfasi",
                name: "GenelYardimSayfasi",
                meta: { title: 'Genel Yardım Sayfası', ust: (r) => r.query.SayfaUrl || null },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Yardim/GenelYardimSayfasi.vue")
            },
            // T3: Sparqon tam sayfa. Rol/WebSayfa kontrolünden muaf (aşağıda yetkiGerekli) — erişim Sparqon
            // lisansıyla (sayfanın içeriğini yalnız lisanslı şirkette yüklenen AIMessenger çizer).
            {
                path: "/sparqon",
                name: "SparqonCalismaAlani",
                meta: { title: 'Sparqon' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Sparqon/SparqonCalismaAlani.vue")
            },
        ]
    },
    { path: "/cagri", redirect: "/cagri/cagrilistesi" },
    {
        path: "/cagri/:CagriNo",
        name: "",
        component: AdminLayout,
        meta: { title: 'Çağrı' },
        children: [
            {
                path: "/cagri/cagrianaliz",
                name: "CagriAnaliz",
                meta: { title: 'Çağrı Analiz' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/CagriAnaliz.vue")
            },
            {
                path: "/cagri/cagrilistesi",
                name: "CagriListesi",
                meta: { title: 'Çağrı Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/CagriListesi.vue")
            },
            {
                path: "/cagri/tumcagrilistesi",
                name: "TumCagriListesi",
                meta: { title: 'Tüm Çağrılar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/TumCagriListesi.vue")
            },
            {
                path: "/cagri/kapanancagrilistesi",
                name: "KapananCagriListesi",
                meta: { title: 'Çözülen / Kapanan Çağrılar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/KapananCagriListesi.vue")
            },
            {
                path: "/cagri/yenicagri",
                name: "CagriTanimla",
                meta: { title: 'Yeni Çağrı', ust: "/cagri/cagrilarim" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/YeniCagri.vue")
            },
            {
                path: "/cagri/duzenlecagri",
                name: "DuzenleCagri2",
                meta: { title: 'Çağrı Düzenle', ust: "/cagri/cagrilistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/DuzenleCagri.vue")
            },
            // Kullanici
            {
                path: "/cagri/cagrilarim",
                name: "Cagrilarim",
                meta: { title: 'Çağrılarım' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kullanici/Cagrilarim.vue")
            },
            {
                path: "/cagri/detaycagri",
                name: "DetayCagri",
                meta: { title: 'Çağrı Detay', ust: "/cagri/cagrilarim" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kullanici/DetayCagri.vue")
            },
            //- Yardım Masa Kategori
            {
                path: "/yardim/ymkategorilistesi",
                name: "YMKategoriListesi",
                meta: { title: 'Kategori Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kategori/KategoriListesi.vue")
            },
            {
                path: "/yardim/ymkategoriduzenle",
                name: "YMKategoriDuzenle",
                meta: { title: 'Kategori Düzenle', ust: "/yardim/ymkategorilistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kategori/DuzenleKategori.vue")
            },
            {
                path: "/yardim/ymkategoriyeni",
                name: "YMKategoriYeni",
                meta: { title: 'Yeni Kategori', ust: "/yardim/ymkategorilistesi" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kategori/YeniKategori.vue")
            },
            {
                path: "/yardim/ymslakurallari",
                name: "YMSlaKurallari",
                meta: { title: 'Hizmet Seviyesi (SLA) Kuralları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Sla/SlaKurallari.vue")
            },
        ]
    },
    // AI Panel
    {
        path: "/aipanel",
        name: "",
        component: AdminLayout,
        meta: { title: 'AI Panel' },
        children: [
            {
                path: "/aipanel/entegrasyonlar",
                name: "AIEntegrasyonListesi",
                meta: { title: 'AI Entegrasyonları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Entegrasyon/EntegrasyonListesi.vue")
            },
            {
                path: "/aipanel/servisler",
                name: "AIServisleri",
                meta: { title: 'AI Servisleri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Servis/ServisListesi.vue")
            },
            {
                path: "/aipanel/aksiyonlog",
                name: "AIAksiyonLog",
                meta: { title: 'AI Aksiyon Log' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/AksiyonLog/AksiyonLog.vue")
            },
            {
                path: "/aipanel/guardrail",
                name: "AIGuardrail",
                meta: { title: 'AI Koruma Kuralları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Guardrail/Guardrail.vue")
            },
            {
                path: "/aipanel/dashboard",
                name: "AIDashboard",
                meta: { title: 'AI Panosu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Dashboard/Dashboard.vue")
            },
            {
                path: "/aipanel/konusmalar",
                name: "AIKanalKonusmalari",
                meta: { title: 'AI Panel Konuşmaları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Konusmalar/KanalKonusmalari.vue")
            },
            {
                path: "/aipanel/telegram",
                name: "AITelegramAyar",
                meta: { title: 'Telegram Botları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/AI_Panel/Telegram/TelegramAyar.vue")
            },
            // TGW-2: kanal-ortak (WhatsApp + Telegram) moderasyon ekranları — /whatsapp/* ile aynı bileşenler,
            // başlık bileşende rota yoluna göre kanal-nötr olur.
            {
                path: "/aipanel/engel",
                name: "AIEngelListesi",
                meta: { title: 'Engel Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPEngelListesi.vue")
            },
            {
                path: "/aipanel/yasaklikelime",
                name: "AIYasakliKelime",
                meta: { title: 'Yasaklı Kelimeler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPYasakliKelime.vue")
            },
            {
                path: "/aipanel/loglar",
                name: "AIMesajLog",
                meta: { title: 'Mesaj Logları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPMesajLog.vue")
            },
        ]
    },
    // Lisans
    // Faz 7 temizligi: eski sağlayıcı-admin /lisans/* sayfaları Sistem Konsolu'na (Faz 6 #16-17)
    // tasindi; /lisans/satinal kiracıya ait, degismedi.
    { path: "/lisans", redirect: "/lisans/satinal" },
    {
        path: "/lisans",
        name: "",
        component: AdminLayout,
        meta: { title: 'Lisans' },
        children: [
            {
                path: "/lisans/lisanssayfa",
                redirect: "/sistem/lisans/sayfa"
            },
            {
                path: "/lisans/lisanstanim",
                redirect: "/sistem/lisans/tanim"
            },
            {
                path: "/lisans/satinal",
                name: "LisansSatinAl",
                meta: { title: 'Lisans Satın Al' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Lisans/LisansSatinAl.vue")
            },

        ]
    },

    // Sistem Konsolu (SK-0 / Faz 1) — yalniz saglayici, erisim kapisi router.beforeEach'te
    // (guard, token bloğundan hemen sonra) fail-closed calisir.
    { path: "/sistem", redirect: "/sistem/genel" },
    {
        path: "/sistem",
        name: "",
        component: SistemLayout,
        meta: { title: 'Sistem Konsolu' },
        children: [
            {
                path: "/sistem/genel",
                name: "SistemKonsolGenel",
                meta: { title: 'Genel' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Genel.vue")
            },
            // GL4: surum + madde + cagri bagi kaydi (GUNCELLEMELER-PLANI.md §8).
            {
                path: "/sistem/guncellemeler",
                name: "SistemGuncellemeler",
                meta: { title: 'Güncellemeler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Guncellemeler.vue")
            },
            // DY4: veritabani yedegi -> NextCloud takibi (DB-YEDEK-PLANI.md §6).
            {
                path: "/sistem/yedekler",
                name: "SistemYedekler",
                meta: { title: 'Veritabanı Yedekleri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yedekler.vue")
            },
            // SK4-Ç2/H (KONSOL-V4): sağlayıcının çağrı masası + kişisel ayarları konsolda — panele gidilmez.
            {
                path: "/sistem/destek/cagrilar",
                name: "SistemDestekCagrilar",
                meta: { title: 'Çağrılar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Destek/CagriMasasi.vue")
            },
            {
                path: "/sistem/destek/cagri",
                name: "SistemDestekCagri",
                // GBH: geçmişsiz açılışta geri, listenin kuyruk filtresini korur (eski "← Çağrılar" bağlantısı gibi).
                meta: { title: 'Çağrı', ust: (r) => (r.query.kuyruk ? { path: "/sistem/destek/cagrilar", query: { kuyruk: r.query.kuyruk } } : "/sistem/destek/cagrilar") },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Destek/CagriDetay.vue")
            },
            // Kategori/SLA: kiracı bileşenleri aynen (SK3-W deseni) — BE uçları KullaniciSirket() ile
            // sağlayıcının kendi kategorilerini/SLA kurallarını görür.
            {
                path: "/sistem/destek/kategoriler",
                name: "SistemDestekKategoriler",
                meta: { title: 'Çağrı Kategorileri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kategori/KategoriListesi.vue")
            },
            {
                path: "/sistem/destek/kategori/yeni",
                name: "SistemDestekKategoriYeni",
                meta: { title: 'Yeni Kategori', ust: "/sistem/destek/kategoriler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kategori/YeniKategori.vue")
            },
            {
                path: "/sistem/destek/kategori/duzenle",
                name: "SistemDestekKategoriDuzenle",
                meta: { title: 'Kategori Düzenle', ust: "/sistem/destek/kategoriler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Kategori/DuzenleKategori.vue")
            },
            {
                path: "/sistem/destek/sla",
                name: "SistemDestekSla",
                meta: { title: 'Hizmet Seviyesi (SLA) Kuralları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/YardımMasa/Sla/SlaKurallari.vue")
            },
            {
                path: "/sistem/hesap",
                name: "SistemHesap",
                meta: { title: 'Hesabım' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Hesap.vue")
            },
            {
                path: "/sistem/uyarilar",
                name: "SistemKonsolUyarilar",
                meta: { title: 'Uyarı Merkezi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Uyarilar.vue")
            },
            // Faz 6 #1: eski /yonetim/sistemdurum'dan tasindi (o rota + bileseni Faz 7'ye kadar
            // geri donus yolu olarak birlikte kaliyor, plan metodolojisi geregi).
            {
                path: "/sistem/durum",
                name: "SistemKonsolDurum",
                meta: { title: 'Sistem Durumu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Durum.vue")
            },
            // Faz 6 #2: eski /yonetim/joblistesi'nden tasindi (o rota + bileseni Faz 7'ye kadar
            // geri donus yolu olarak birlikte kaliyor, plan metodolojisi geregi).
            {
                path: "/sistem/joblar",
                name: "SistemKonsolJoblar",
                meta: { title: 'Görevler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Joblar.vue")
            },
            // Faz 6 #3: eski /yonetim/servis-log'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/servis-log",
                name: "SistemKonsolServisLog",
                meta: { title: 'Servis Log' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/ServisLog.vue")
            },
            // Faz 6 #4: eski /yonetim/sqlolaylogu'ndan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/sql-olay",
                name: "SistemKonsolSqlOlay",
                meta: { title: 'SQL Olay Logu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/SqlOlay.vue")
            },
            // Faz 6 #10: eski /yonetim/hatakural'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/ayarlar/hatakural",
                name: "SistemKonsolHataKural",
                meta: { title: 'Hata Kuralları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/HataKural.vue")
            },
            // Faz 6 #11: eski /yonetim/mailsablon'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/ayarlar/mailsablon",
                name: "SistemKonsolMailSablon",
                meta: { title: 'Mail Şablon Testi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/MailSablon.vue")
            },
            // Faz 6 #12: eski /yonetim/sistem/tabloboyut'tan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/ayarlar/tabloboyut",
                name: "SistemKonsolTabloBoyut",
                meta: { title: 'Tablo Boyutları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/TabloBoyut.vue")
            },
            // Faz 6 #13: eski /yonetim/disbesinkatalogu'ndan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/ayarlar/besinkatalogu",
                name: "SistemKonsolDisBesinKatalogu",
                meta: { title: 'Dış Besin Kataloğu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/DisBesinKatalogu.vue")
            },
            // Faz 6 #6: eski /yonetim/sparqonlog'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/sparqon/log",
                name: "SistemKonsolSparqonLog",
                meta: { title: 'Sparqon Logları', ust: "/sistem/sparqon/ayar" }, // GBH
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sparqon/SparqonLog.vue")
            },
            // Faz 6 #7: eski /yonetim/sparqonayar'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/sparqon/ayar",
                name: "SistemKonsolSparqonAyar",
                meta: { title: 'Sparqon Ayarları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sparqon/SparqonAyar.vue")
            },
            // Faz 6 #8: eski /yonetim/sparqonyetenek'ten tasindi (ayni geri donus kurali).
            {
                path: "/sistem/sparqon/yetenek",
                name: "SistemKonsolSparqonYetenek",
                meta: { title: 'Sparqon Yetenekleri', ust: "/sistem/sparqon/ayar" }, // GBH
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sparqon/SparqonYetenek.vue")
            },
            // IZ-K: Istatistik grubu (ISTATISTIK-VE-IZLEME-PLANI.md V1) — konsol sayfasi, WebSayfa kaydi yok.
            { path: "/sistem/istatistik", redirect: "/sistem/istatistik/trafik" },
            {
                path: "/sistem/istatistik/trafik",
                name: "SistemIstatistikTrafik",
                meta: { title: 'Trafik' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Istatistik/Trafik.vue")
            },
            {
                path: "/sistem/istatistik/kullanim",
                name: "SistemIstatistikKullanim",
                meta: { title: 'Kullanım' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Istatistik/Kullanim.vue")
            },
            {
                path: "/sistem/istatistik/performans",
                name: "SistemIstatistikPerformans",
                meta: { title: 'Performans' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Istatistik/Performans.vue")
            },
            {
                path: "/sistem/istatistik/nps",
                name: "SistemIstatistikNps",
                meta: { title: 'NPS' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Istatistik/Nps.vue")
            },
            // SK-P: paket yonetimi + vitrin yayini.
            {
                path: "/sistem/urun/paketler",
                name: "SistemPaketListesi",
                meta: { title: 'Paketler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Urun/PaketListesi.vue")
            },
            {
                path: "/sistem/urun/paketler/:pPaket",
                name: "SistemPaketDuzenle",
                meta: { title: 'Paket', ust: "/sistem/urun/paketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Urun/PaketDuzenle.vue")
            },
            {
                path: "/sistem/urun/indirimler",
                name: "SistemIndirimListesi",
                meta: { title: 'İndirim Kademeleri', ust: "/sistem/urun/paketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Urun/IndirimListesi.vue")
            },
            {
                path: "/sistem/urun/onizleme",
                name: "SistemVitrinOnizleme",
                meta: { title: 'Vitrin Önizleme', ust: "/sistem/urun/paketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Urun/VitrinOnizleme.vue")
            },
            // SK-E: ek katalogu (koltuk/sube/modulpro/hizmet) - Paketler ekranindaki
            // Indirimler/Vitrin Onizleme ile ayni buton deseni (ayri menu maddesi degil).
            {
                path: "/sistem/urun/ekler",
                name: "SistemEkListesi",
                meta: { title: 'Ekler', ust: "/sistem/urun/paketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Urun/EkListesi.vue")
            },
            {
                path: "/sistem/urun/ekler/:pEk",
                name: "SistemEkDuzenle",
                meta: { title: 'Ek', ust: "/sistem/urun/ekler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Urun/EkDuzenle.vue")
            },
            // SK-S: sirket 360 (askiya alma + sirkete gec + notlar + denetim).
            {
                path: "/sistem/sirketler",
                name: "SistemSirketListesi",
                meta: { title: 'Şirketler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sirketler/SirketListesi.vue")
            },
            {
                path: "/sistem/sirketler/:SirketNo",
                name: "SistemSirket360",
                meta: { title: 'Şirket', ust: "/sistem/sirketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sirketler/Sirket360.vue")
            },
            // Faz 6 #14: eski /yonetim/demotalepleri + demotalepdetay'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/sirketler/demo-talepler",
                name: "SistemDemoTalepListesi",
                meta: { title: 'Demo Talepleri', ust: "/sistem/sirketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sirketler/DemoTalepListesi.vue")
            },
            {
                path: "/sistem/sirketler/demo-talepler/detay",
                name: "SistemDemoTalepDetay",
                meta: { title: 'Demo Talep Detayı', ust: "/sistem/sirketler/demo-talepler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sirketler/DemoTalepDetay.vue")
            },
            // Faz 6 #25: eski /sirket/sirketkayit/sihirbaz'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/sirketler/yeni",
                name: "SistemSirketSihirbazi",
                meta: { title: 'Yeni Şirket Sihirbazı', ust: "/sistem/sirketler" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Sirketler/SirketSihirbazi.vue")
            },
            // KSY1: sube ekle/duzenle konsolda (kiraci /sirket/sube/* BA8 ile kapali, SK4-G panel
            // rotasini Pano'ya ceviriyordu). Ayni bilesenler; donus Sirket 360 → Ayarlar → Subeler.
            {
                path: "/sistem/sirketler/:SirketNo/sube/yeni",
                name: "SistemSubeYeni",
                meta: { title: 'Yeni Şube', ust: (r) => ({ path: "/sistem/sirketler/" + r.params.SirketNo, query: { sekme: "ayarlar", bolum: "sube" } }) },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Sirket/Sube/YeniSube.vue")
            },
            {
                path: "/sistem/sirketler/:SirketNo/sube/duzenle",
                name: "SistemSubeDuzenle",
                meta: { title: 'Şube Düzenle', ust: (r) => ({ path: "/sistem/sirketler/" + r.params.SirketNo, query: { sekme: "ayarlar", bolum: "sube" } }) },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Yönetim/Sirket/Sube/DuzenleSube.vue")
            },
            // Faz 6 #16: eski /lisans/lisanstanim'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/lisans/tanim",
                name: "SistemLisansTanim",
                meta: { title: 'Lisans Tanımları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Lisans/LisansTanim.vue")
            },
            // Faz 6 #17: eski /lisans/lisanssayfa'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/lisans/sayfa",
                name: "SistemLisansSayfa",
                meta: { title: 'Lisans Sayfa Atama' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Lisans/LisansSayfa.vue")
            },
            // Faz 6 #19: eski /yonetim/yetki'den tasindi (ayni geri donus kurali).
            {
                path: "/sistem/yetki/yetkiyeri",
                name: "SistemYetkiYerleri",
                meta: { title: 'Yetki Yerleri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/YetkiYerleri.vue")
            },
            // Faz 6 #20: eski /yonetim/websayfa'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/yetki/websayfa",
                name: "SistemWebSayfalar",
                meta: { title: 'Web Sayfaları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/WebSayfalar.vue")
            },
            // Faz 6 #18: eski /yonetim/rolyetki'den tasindi (ayni geri donus kurali).
            {
                path: "/sistem/yetki/rolyetki",
                name: "SistemRolYetki",
                meta: { title: 'Rol Yetkileri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/RolYetki.vue")
            },
            // Faz 6 #22-24: eski /yardim/*'dan tasindi (ayni geri donus kurali).
            {
                path: "/sistem/yardim",
                name: "SistemYardimListesi",
                meta: { title: 'Yardım' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yardim/YardimListesi.vue")
            },
            {
                path: "/sistem/yardim/yeni",
                name: "SistemYeniYardim",
                meta: { title: 'Yeni Yardım', ust: "/sistem/yardim" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yardim/YeniYardim.vue")
            },
            {
                path: "/sistem/yardim/duzenle",
                name: "SistemDuzenleYardim",
                meta: { title: 'Yardım Metni Düzenle', ust: "/sistem/yardim" },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yardim/DuzenleYardim.vue")
            },
            // SK-S: duyuru merkezi.
            {
                path: "/sistem/duyurular",
                name: "SistemDuyurular",
                meta: { title: 'Duyurular' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Duyurular.vue")
            },
            // SK-I: entegrasyon merkezi (kart ızgarası, sır maskeli ayar formu, sağlık job'u ile ortak katalog).
            {
                path: "/sistem/entegrasyonlar",
                name: "SistemEntegrasyonlar",
                meta: { title: 'Entegrasyonlar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Entegrasyonlar.vue")
            },
            // SK-R Faz 1: tum sirketlerin siparisleri (durum filtresi, aktif et/iptal) - LS karar 2
            // geregi Lisans sekmesindeki "Siparisler" karti buraya tasindi.
            {
                path: "/sistem/siparisler",
                name: "SistemSiparisler",
                meta: { title: 'Siparişler' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Gelir/Siparisler.vue")
            },
            // SK-R Faz 2: gelir paneli - MRR/ARR, yenileme takvimi, churn, huni, ek dagilimi, sirket bazli MRR.
            {
                path: "/sistem/gelir",
                name: "SistemGelir",
                meta: { title: 'Gelir' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Gelir/Gelir.vue")
            },
            // SK-R Faz 3: kullanim raporlari (AI token, aktif kullanici, kullanilmayan lisanslar) + WhatsApp kota (Faz 6 #5 - eski /yonetim/whatsappkota'dan tasindi).
            {
                path: "/sistem/raporlar",
                name: "SistemRaporlar",
                meta: { title: 'Kullanım Raporları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Raporlar/Raporlar.vue")
            },
            // SK3-W: WhatsApp grubu. Kota raporu /sistem/raporlar/whatsapp'tan taşındı (eski yol redirect).
            {
                path: "/sistem/whatsapp/kota",
                name: "SistemWhatsAppKota",
                meta: { title: 'Kota Raporu' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Raporlar/WhatsAppKota.vue")
            },
            {
                path: "/sistem/whatsapp/havuz",
                name: "SistemWhatsAppHavuz",
                meta: { title: 'Havuz Numaraları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/WhatsApp/HavuzNumaralari.vue")
            },
            {
                path: "/sistem/whatsapp/sablonlar",
                name: "SistemWhatsAppSablonlar",
                meta: { title: 'Global Şablonlar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/WhatsApp/GlobalSablonlar.vue")
            },
            // SK3-W (V9): HepyApp'in kendi hattı — kiracı bileşenleri aynen, SistemLayout içinde.
            // BE uçları KullaniciSirket() ile sağlayıcı şirketi (HepyApp) görür; değişiklik yok.
            {
                path: "/sistem/whatsapp/hat/numaralar",
                name: "SistemWhatsAppHatNumaralar",
                meta: { title: 'HepyApp Hattı · Numaralar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPEntegrasyonListesi.vue")
            },
            // SKB-E3: HepyApp kanalları (WhatsApp hattı + Telegram botu) — ana anahtarlar + asistan aç/kapa.
            // Loglar/engel/yasaklı/asistan eskiden /sistem/whatsapp/hat/... idi (aşağıda redirect); bileşenler iki kanallı.
            {
                path: "/sistem/kanallar/ayar",
                name: "SistemKanallarAyar",
                meta: { title: 'HepyApp Kanalları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Kanal/KanalAyar.vue")
            },
            {
                path: "/sistem/kanallar/loglar",
                name: "SistemWhatsAppHatLoglar",
                meta: { title: 'HepyApp Kanalları · Loglar' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPMesajLog.vue")
            },
            {
                path: "/sistem/kanallar/asistan",
                name: "SistemWhatsAppHatAsistan",
                meta: { title: 'HepyApp Kanalları · Asistan Profili' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPAsistanAyar.vue")
            },
            {
                path: "/sistem/kanallar/engel",
                name: "SistemWhatsAppHatEngel",
                meta: { title: 'HepyApp Kanalları · Engel Listesi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPEngelListesi.vue")
            },
            {
                path: "/sistem/kanallar/yasakli",
                name: "SistemWhatsAppHatYasakli",
                meta: { title: 'HepyApp Kanalları · Yasaklı Kelime' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/WhatsApp/WPYasakliKelime.vue")
            },
            // SK3-Y: konsol rolleri + kullanıcı ataması + denetim kaydı.
            {
                path: "/sistem/yetki/kullanicilar",
                name: "SistemKonsolKullanicilari",
                meta: { title: 'Konsol Kullanıcıları' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/KonsolKullanicilari.vue")
            },
            {
                path: "/sistem/yetki/roller",
                name: "SistemKonsolRolleri",
                meta: { title: 'Konsol Rolleri' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/KonsolRolleri.vue")
            },
            {
                path: "/sistem/yetki/denetim",
                name: "SistemKonsolDenetim",
                meta: { title: 'Denetim Kaydı' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/Denetim.vue")
            },
            // Y5: global modül yetki filtresi — mod anahtarı + red logu.
            {
                path: "/sistem/yetki/filtre",
                name: "SistemYetkiFiltresi",
                meta: { title: 'Modül Yetki Filtresi' },
                component: () =>
                    import("./components/HepyApp/PrivatePage/Sistem/Yetki/YetkiFiltresi.vue")
            },
        ]
    },
    { path: "/sistem/raporlar/whatsapp", redirect: "/sistem/whatsapp/kota" },
    { path: "/sistem/kanallar", redirect: "/sistem/kanallar/ayar" },
    { path: "/sistem/whatsapp/hat/loglar", redirect: "/sistem/kanallar/loglar" },
    { path: "/sistem/whatsapp/hat/asistan", redirect: "/sistem/kanallar/asistan" },
    { path: "/sistem/whatsapp/hat/engel", redirect: "/sistem/kanallar/engel" },
    { path: "/sistem/whatsapp/hat/yasakli", redirect: "/sistem/kanallar/yasakli" },

    {
        path: "/hata-erisim-yetkisi",
        meta: { title: 'Erişim Yetkisi' },
        component: () =>
            import("./components/HataSayfalari/Hata_ErisimYetkisi.vue"),
    },
    {
        path: "/lisans-yok",
        meta: { title: 'Lisans Yok' },
        component: () =>
            import("./components/HataSayfalari/LisansYok.vue"),
    },
    {
        path: "/Hata_ErisimYetkisi",
        redirect: "/hata-erisim-yetkisi",
    },
    {
        // MOB M1-1: kurulu uygulama sürümü artık desteklenmiyor — yalnız "yeni sürümü kurun".
        path: "/yeni-surum-kurun",
        meta: { title: 'Yeni Sürüm' },
        component: () =>
            import("./components/HataSayfalari/YeniSurumKurun.vue"),
    },
    {
        // MOB M1-0 (K5): mobil uygulamada sağlayıcı konsolu yok — bilgi + çıkış.
        path: "/masaustunde-acin",
        meta: { title: 'Masaüstünde Açın' },
        component: () =>
            import("./components/HataSayfalari/MasaustundeAcin.vue"),
    },
    {
        path: "/oturum-suresi-bitti",
        meta: { title: 'Süre Bitti' },
        component: () =>
            import("./components/HataSayfalari/OturumSuresiBitti.vue"),
    },
    {
        path: "/OturumSuresiBitti",
        redirect: "/oturum-suresi-bitti",
    },
    {
        path: "/not-found",
        meta: { title: 'Bulunamadı' },
        component: () =>
            import("./components/HataSayfalari/NotFound.vue"),
    },
    {
        path: "/NotFound",
        redirect: "/not-found",
    },
    // {
    //     path: "/RandevuSistemi/RandevuAl",
    //     name: "RandevuAl",
    //     component: () =>
    //         import("./components/HepyApp/PublicPage/Randevu/RandevuAl.vue")
    // },
    // SAT-4: self-servis hesap açma (public; hepy.app fiyat sayfası "Bu seçimle satın al" buraya gelir)
    {
        path: "/kayit",
        component: AuthLayout,
        meta: { title: 'Hesap Oluştur' },
        children: [{
            path: "",
            name: "SelfKayit",
            component: () => import("./components/HepyApp/PublicPage/Kayit/SelfKayit.vue")
        }]
    },
    { path: "/randevusistemi", redirect: "/randevusistemi/randevual" },
    {
        path: "/randevusistemi",
        name: "",
        component: AuthLayout,
        meta: { title: 'Randevu Al Form' },
        children: [{
            path: "/randevusistemi/randevual",
            name: "RandevuAl2",
            component: () =>
                import("./components/HepyApp/PublicPage/Randevu/RandevuAl.vue")
        },
        {
            // Onay/hatırlatma mailindeki bağlantı — kimlik yalnız ?token=. Görüntüle +
            // yeniden planla (H5) + iptal hepsi burada; path aynı kaldı ki eski mailler kırılmasın.
            path: "/randevusistemi/randevuiptal",
            name: "RandevuIptal",
            component: () =>
                import("./components/HepyApp/PublicPage/Randevu/RandevuMusteriIslem.vue")
        }
        ]
    },

    { path: "/cagrisistemi", redirect: "/cagrisistemi/cagriolustur" },
    {
        path: "/cagrisistemi/:SubeGuid",
        name: "",
        component: AuthLayout,
        meta: { title: 'Çağrı Form' },
        children: [{
            path: "/cagrisistemi/cagriolustur",
            name: "CagriOlustur3",
            component: () =>
                import("./components/HepyApp/PublicPage/YardimMasa/CagriOlustur.vue")
        },
        {
            path: "/cagrisistemi/cagritakip",
            name: "CagriTakip",
            component: () =>
                import("./components/HepyApp/PublicPage/YardimMasa/CagriTakip.vue")
        }
        ]
    },

    {
        path: "/teklif/:SubeGuid",
        name: "",
        component: AuthLayout,
        meta: { title: 'Talep Oluştur' },
        children: [{
            path: "/teklif/talepolustur",
            name: "TalepOlustur",
            component: () =>
                import("./components/HepyApp/PublicPage/Talep/TalepOlustur.vue")
        }
        ]
    },

    //  {
    //     path: "/Basvuru/BasvuruForm/:SirketGuid",
    //     name: "BasvuruForm",
    //     component: () =>
    //         import("./components/HepyApp/PublicPage/BasvuruForm/BasvuruForm.vue")
    // },
    { path: "/onkayit", redirect: "/onkayit/onkayitform" },
    {
        path: "/onkayit:SubeGuid",
        name: "",
        component: AuthLayout,
        meta: { title: 'Başvuru Form' },
        children: [{
            path: "/onkayit/onkayitform",
            name: "OnKayitForm",
            component: () =>
                import("./components/HepyApp/PublicPage/OnKayitForm/OnKayitForm.vue")
        }
        ]
    },

    {
        path: "/public/teklif/:token",
        name: "",
        component: AuthLayout,
        meta: { title: 'Teklif' },
        children: [{
            path: "/public/teklif/:token",
            name: "PublicTeklif",
            component: () =>
                import("./components/HepyApp/PublicPage/Teklif/PublicTeklifGoruntule.vue")
        }
        ]
    },

    // Blog katalogları (public / iframe ile gömülen sayfalar). Layout YOK — embed
    // içinde menü/footer istemiyoruz, sayfalar kendi kabuğunu çiziyor.
    // Önek bilerek /blog değil: guard'daki startsWith('/blog/y…') kontrolü
    // yönetim sayfası /blog/yazilar ile çakışır ve onu public sayardı.
    {
        path: "/katalog/:guid",
        name: "PublicBlogListe",
        meta: { title: 'Katalog' },
        component: () =>
            import("./components/HepyApp/PublicPage/Blog/PublicBlogListe.vue")
    },
    {
        path: "/katalog/:guid/:slug",
        name: "PublicBlogDetay",
        meta: { title: 'Yazı' },
        component: () =>
            import("./components/HepyApp/PublicPage/Blog/PublicBlogDetay.vue")
    },

    { path: '/:pathMatch(.*)*', redirect: '/not-found' },
];

// Aktif lisans şartından muaf sayfalar — BE CosDLL.YetkiKontrol.LisansMuafSayfaUrller ile aynı liste.
// Satın al + (SAT-8) lisanssız şirketin HepyApp Destek'e çağrısı; rol yetkisi yine kontrol edilir.
const LISANS_MUAF_YOLLAR = ['/lisans/satinal', '/cagri/cagrilarim', '/cagri/yenicagri', '/cagri/detaycagri'];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { top: 0, behavior: 'smooth' };
    },
});

import { Servis, ensureRefreshed } from '../src/services/Servis';
import AuthService from './services/auth.service';
import { uiState, menuTtlDoldu } from './services/uiState';
import { esPublicYolMu, zorunluHedefMi, yetkiKontroluMuafMi } from './services/rotaMuafiyet';
import { kirliVarMiHemen, aktifSayfaMuafMi, ayniYolSorulurMu, cikisOnayiAl, onayVerildi, onayGecerliMi, onaySifirla, bekleyenOnayiKapat } from './services/kirliKayit';
import { temaUygula, acikZorla, kayitliTema } from './services/tema';
import { boyutUygula, normalZorla, kayitliBoyut } from './services/alanBoyutu';
import { chunkHatasiMi, yeniSurumUyarisiAc } from './services/yeniSurum';
import { sistemKonsol, rotaAlani, alanVar, ALAN_ADLARI, konsolYetkisiYukle, konsolYetkisiGuncelMi, girisSonrasiRota, saglayiciPanelHedefi } from './services/sistemKonsol';
import { yerelUygulama, mobilDurum } from './services/platform'; // MOB M1-0 / M1-1
import olcum from './services/olcum'; // IZ-P: panel GA4 (VUE_APP_GA_ID bossa no-op)
import { secimiSorgudanKaydet } from './services/satinAlSecim';

// OT-3e: silme AuthService.yerelOturumuSil'den geçer (başka sekme yenilediyse depo silinmez). Çağıranlar
// zaten oturum dışı bir sayfaya (login / Oturum süresi bitti) yönlendiriyor.
function clearAuthData() {
    if (!AuthService.yerelOturumuSil()) return false;
    store.dispatch('auth/logout', null, { root: true });
    return true;
}

// KDU (Dokumanlar/Arayuz/KAYDEDILMEMIS-DEGISIKLIK-PLANI.md §4.3): kaydedilmemiş değişiklik onayı.
// Mevcut beforeEach'ten ÖNCE kayıtlı → navLoading/bootLoading açılmadan ve yetki API'si çağrılmadan
// sorulur; "Sayfada kal" (false) gezinmeyi iptal eder, popstate'te router adresi kendisi geri alır.
// Defter boşsa (form olmayan sayfalar) maliyet tek döngü.
router.beforeEach(async (to, from) => {
    if (!kirliVarMiHemen()) return true;
    const hedef = to.path.toLowerCase();
    if (zorunluHedefMi(hedef)) return true;                                  // V5 — oturum bitti / yetki yok / login
    if (from.path && hedef === from.path.toLowerCase() && !ayniYolSorulurMu(to, from)) return true; // V6 — yalnız query/hash (sekme deep-link); kayıt kimliği query'deyse sayfa kirliAyniYolSorar ile sordurur
    if (onayGecerliMi(from.fullPath)) return true;                           // onay sonrası guard yönlendirme zinciri
    if (aktifSayfaMuafMi(to)) return true;                                   // V10 — sayfanın kirliMuaf(to) kancası
    const izin = await cikisOnayiAl('sayfa');
    if (!izin) return false;
    onayVerildi(from.fullPath);
    return true;
});

router.beforeEach(async (to, from, next) => {
    const path = to.path.toLowerCase();
    const isPublic = esPublicYolMu(path, to.fullPath);

    // MOB M1-1: eski native kabuk — paneli açmadan yalnız "yeni sürümü kurun".
    if (yerelUygulama && mobilDurum.nativeEski && path !== '/yeni-surum-kurun') {
        return next('/yeni-surum-kurun');
    }

    // Tema (Açık/Koyu) tek kaynak = hepyTema (services/tema). Eski 'theme' anahtarı
    // KULLANILMIYOR — okunursa her navigasyonda dark sınıflarını söküp navbar'ı beyaza
    // döndürüyordu. temaUygula sınıfları (add/remove) tutarlı biçimde yönetir.
    // KT0: public rotada (hata sayfaları dahil) her zaman açık — ve KAYDETMEDEN, aksi halde
    // cihazın koyu tercihi silinir. Private rotada bugünkü davranış aynen sürer.
    if (isPublic) {
        acikZorla(); // MD-1: sistem teması değişse de public sayfa açık kalır
        normalZorla(); // AB1: dışarı açık formlar her zaman normal boyut, tercih silinmez
    } else {
        temaUygula(kayitliTema());
        boyutUygula(kayitliBoyut());
    }

    // Hata sayfaları her zaman erişilebilir
    if (path === '/not-found' || path === '/hata-erisim-yetkisi' || path === '/oturum-suresi-bitti') {
        return next();
    }

    // LOGIN SAYFASI
    if (path === '/auth/login') {
        const token = depo.oku('token');
        const tokenExp = depo.oku('tokenExpiration');

        // Token geçerliyse (zaten giriş yapmış) — SK3-M/K2: sağlayıcı kullanıcısı konsol panosuna,
        // diğerleri Admin'e (Login.vue'daki giriş sonrası yönlendirmeyle aynı karar).
        // SAT-9 (K14): gönüllü /auth/login ziyaretinde yönlendirme yok — Login hesap seçici kartı
        // gösterir (lisanssız hesapta /admin/main → /lisans-yok döngüsünden çıkış). Kök adres ("/",
        // "/auth") yönlendirmesiyle gelindiyse eskisi gibi doğrudan panele.
        if (token && tokenExp && Date.now() < parseInt(tokenExp)) {
            if (to.redirectedFrom) return next(await girisSonrasiRota());
            return next();
        }

        // OT-4: erişim anahtarı dolmuş ama yenileme anahtarı var → silinmez; Login.vue önce yenilemeyi
        // dener (başarılıysa "oturumunuz açık" kartı). Silmek bu tarayıcıdaki öbür sekmeleri de düşürürdü.
        if (token && depo.oku("refreshToken")) return next();

        // Token yok veya süresi dolmuş → temizle ve login sayfasını göster
        clearAuthData();
        return next();
    }

    // Diğer public sayfalar (şifre sıfırlama, randevu, vs.)
    if (isPublic) {
        return next();
    }

    // --- KORUMALI SAYFALAR ---

    const token = depo.oku('token');
    const tokenExp = depo.oku('tokenExpiration');

    // Token yoksa login sayfasına yönlendir
    if (!token || !tokenExp) {
        clearAuthData();
        // YNL1-2: e-postadaki "Süreyi uzat" (/lisans/satinal?uzat=...) — seçim saklanır, girişten
        // sonra girisSonrasiRota() onu görüp Satın Al'ı hazır seçimle açar.
        if (path === '/lisans/satinal') secimiSorgudanKaydet(to.query);
        return next('/auth/login');
    }

    // Aynı sayfada yalnızca query/hash değişti (örn. bir bölüm/sekme seçimi, deep-link için
    // router.replace ile). Bu path bu oturumda zaten yetkilendirildi — tekrar yetki API'sine
    // gidip tam ekran "Yükleniyor" göstermeye gerek yok (her sekme tıklamasında sayfa "komple
    // yenileniyor" hissi buradan geliyordu — guard, query-only navigasyonlarda da çalışıyordu).
    if (from.path && path === from.path.toLowerCase()) {
        return next();
    }

    // Korumalı sayfada async kontroller (refresh / lisans / yetki) basliyor. AdminLayout
    // zaten ekrandaysa (oturum ici gecis) navLoading -> ince cubuk; degilse (ilk yukleme /
    // giristen hemen sonra, henuz gosterilecek bir kabuk yok) bootLoading -> tam ekran ekran.
    const bootGecisi = from.matched.length === 0 || esPublicYolMu(from.path.toLowerCase(), from.fullPath);
    if (bootGecisi) {
        uiState.bootLoading = true;
    } else {
        uiState.navLoading = true;
    }

    // Access token süresi dolmuşsa: refresh token varsa yenilemeyi dene, yoksa/başarısızsa sonlandır
    if (Date.now() > parseInt(tokenExp)) {
        if (depo.oku('refreshToken')) {
            const ok = await ensureRefreshed();
            if (!ok) {
                clearAuthData();
                return next('/oturum-suresi-bitti');
            }
            // yenilendi → devam
        } else {
            clearAuthData();
            return next('/oturum-suresi-bitti');
        }
    } else if (AuthService.shouldRefreshToken() && depo.oku('refreshToken')) {
        // Süre bitmeden (<15 dk) proaktif yenile — 401 round-trip'i yaşanmasın. Başarısız olursa
        // (refresh token artık geçersiz) sessizce yutup her sayfa geçişinde tekrar denemek yerine -
        // aynı "süresi dolmuş" dalıyla oturumu temizleyip erkenden net bir şekilde sonlandır.
        const ok = await ensureRefreshed();
        if (!ok) {
            clearAuthData();
            return next('/oturum-suresi-bitti');
        }
    }

    // SK4-G (KONSOL-V4 K2/K7): sağlayıcı ekibi (konsol erişimi olan oturum) kiracı panelini
    // kullanmaz — panel adresi konsol karşılığına ya da konsol panosuna çevrilir. "Şirkete geç"
    // (impersonation) oturumu hariç: o zaten kiracı görünümü — ayrı bir istemci bayrağıyla değil,
    // BE'nin impersonation token'ına Erisim=false dönmesiyle (bayat sessionStorage bayrağı guard'ı
    // atlatıp sağlayıcıyı /hata-erisim-yetkisi döngüsüne sokuyordu). Konsol yetkisi token başına bir
    // kez sorulur (kiracı için de tek istek). Fail-safe: istek hata verirse eski davranış (panel).
    // BE tarafı ayrıca kapalı (SK4-G2: GetNavbar boş, GetYetkiKontrol false).
    if (!path.startsWith('/sistem')) {
        try {
            if (!konsolYetkisiGuncelMi()) await konsolYetkisiYukle();
            if (sistemKonsol.erisim === true) {
                const hedef = saglayiciPanelHedefi(to);
                if (hedef) {
                    sistemKonsol.panelUyari = 'Sağlayıcı ekibi kiracı panelini kullanmaz; kiracı görünümü için Şirket 360 → Şirkete geç.';
                    return next(hedef);
                }
            }
        } catch (e) {
            // eski davranış
        }
    }

    // Sistem Konsolu (SK-0 / Faz 1): lisans kontrolunden ÖNCE, ayrı ve fail-closed bir kapı —
    // yalnız 200 + true geçer, 401/403 oturum sonlandırır, her diğer durum (400/999/ağ hatası
    // dahil) erişim reddi sayılır. Saglayici sirketin normal kiraci lisansi olmayabilir, o yüzden
    // bu dal aşağıdaki GetAktifLisansVarMi kontrolüne hiç girmeden karar verir.
    // SK3-Y: yanıt {Erisim, Anahtarlar[], RolAd, VarsayilanRota}; rotanın grubu (rotaAlani —
    // services/sistemKonsol menü tanımı) rolün anahtarlarında yoksa 403 sayfası değil pano + toast
    // (kullanıcı zaten konsolda). Uç kapısı BE'de ayrıca aynı anahtara bakar.
    if (path.startsWith('/sistem')) {
        try {
            const res = await konsolYetkisiYukle();
            if (res.status === 200 && res.data && res.data.Erisim === true) {
                // MOB M1-0 (K5): konsol mobil uygulamada açılmaz.
                if (yerelUygulama) return next('/masaustunde-acin');
                const alan = rotaAlani(path);
                if (!alanVar(alan)) {
                    sistemKonsol.yetkisizUyari = 'Bu bölüm (' + (ALAN_ADLARI[alan] || alan) + ') için konsol yetkiniz yok.';
                    if (path !== '/sistem/genel') return next('/sistem/genel');
                }
                document.title = to.meta.title || 'Hepy.app';
                return next();
            }
            if (res.status === 401 || res.status === 403) {
                clearAuthData();
                return next('/oturum-suresi-bitti');
            }
            return next('/hata-erisim-yetkisi');
        } catch (e) {
            return next('/hata-erisim-yetkisi');
        }
    }

    // Lisans yok sayfasının kendisi serbest (döngü olmasın)
    if (path === '/lisans-yok') {
        return next();
    }

    // Şirketin aktif lisansı yoksa lisans-yok sayfasına yönlendir (oturum başına 1 kez sorulur)
    // Yalnızca API kesin "false" derse yönlendir; 404/500/hata durumunda kilitleme (fail-open)
    // LISANS_MUAF_YOLLAR İSTİSNA: lisansı olmayan kullanıcı da lisans satın alabilmeli ve HepyApp'e çağrı açabilmeli —
    // burada atlanan yalnızca lisans-yok yönlendirmesi, aşağıdaki GetYetkiKontrol çağrısı
    // (WebSayfa/YetkiYeri kaydı) yine normal şekilde çalışır.
    //
    // Lisans + yetki çağrıları birbirine bağlı değil — eskiden sırayla bekleniyordu (yetki,
    // lisans tamamen bitmeden hiç başlamıyordu), her korumalı geçişte gereksiz gecikme
    // ekliyordu. Artık ikisi de hemen (aynı anda) başlatılıp kendi hata kurallarıyla ayrı ayrı
    // beklenir. Tek yan etki: lisansı olmayan bir şirkette (nadir) GetYetkiKontrol sonucu
    // kullanılmadan atılmış olabilir — kabul edilebilir, davranış/karar değişmiyor.
    const lisansGerekli = !LISANS_MUAF_YOLLAR.includes(path);
    // /sparqon (T3): rol kontrolünden muaf, Sparqon lisansıyla korunur (kullanıcı kararı 2026-09-25).
    const yetkiGerekli = !yetkiKontroluMuafMi(path); // SPQ1: AdminLayout yeniden kontrolüyle aynı liste

    const lisansCagrisi = (lisansGerekli && sessionStorage.getItem('aktifLisansVar') === null)
        ? Servis('GET', 'GetAktifLisansVarMi', '') : null;
    const yetkiCagrisi = yetkiGerekli ? Servis('POST', 'GetYetkiKontrol', { URL: to.href }) : null;

    if (lisansGerekli) {
        try {
            let lisansVar = sessionStorage.getItem('aktifLisansVar');
            if (lisansVar === null) {
                const lisansRes = await lisansCagrisi;
                if (lisansRes.status === 200) {
                    lisansVar = (lisansRes.data === true) ? '1' : '0';
                    sessionStorage.setItem('aktifLisansVar', lisansVar);
                } else {
                    // Kontrol edilemedi (ör. endpoint yok / sunucu hatası) → engelleme, cache'leme
                    lisansVar = '1';
                }
            }
            if (lisansVar === '0') {
                return next('/lisans-yok');
            }
        } catch (e) {
            // Kontrol edilemezse kilitleme, normal akışa devam et
            console.warn('Lisans kontrolü yapılamadı');
        }
    }

    // Genel yardım sayfası her yetkili kullanıcıya açık (per-page lisans/rol kontrolünden muaf)
    if (!yetkiGerekli) {
        return next();
    }

    // Token geçerli — API'den yetki kontrolü yap
    try {
        const res = await yetkiCagrisi;

        if (res.status === 200 && res.data === true) {
            // Sayfa başlığı kritik yol değil — next()'i beklemeden arka planda ayarlanır
            // (eskiden bu çağrı bitene kadar navigasyonun kendisi bloke oluyordu).
            Servis('GET', 'GetSayfaBaslik', { URL: to.href }).then((baslikRes) => {
                if (baslikRes.status === 200 && baslikRes.data?.[0]?.SayfaBaslik) {
                    document.title = `${baslikRes.data[0].SayfaBaslik} | ${to.meta.title || ''}`;
                }
            }).catch(() => console.warn('Sayfa başlığı alınamadı'));
            return next();
        }

        if (res.status === 401 || res.status === 403) {
            clearAuthData();
            return next('/oturum-suresi-bitti');
        }

        if (res.status === 400 || res.data === false) {
            // Yetki reddi, rol/lisans değişikliğinin gecikmiş sinyali olabilir (NB planı) —
            // navbar bir sonraki TTL/odak kontrolünde tazelensin, lisans cache'i de bayat kalmasın.
            uiState.menuTazeleGerekli = true;
            sessionStorage.removeItem('aktifLisansVar');
            return next('/hata-erisim-yetkisi');
        }

        // 999 = iş kuralı reddi (Y5 modül filtresi dahil) — oturum geçerli, kullanıcıyı çıkarma.
        // Eskiden oturum-suresi-bitti'ye gidip oturumu temizliyordu: giriş → 999 → çıkış döngüsü.
        if (res.status === 999) {
            return next('/hata-erisim-yetkisi');
        }

        // Diğer beklenmeyen durumlar → oturum sonlandı
        return next('/oturum-suresi-bitti');
    } catch (err) {
        console.error('Yetki kontrol hatasi:', err);
        // Servis() validateStatus:true kullandığı için buraya pratikte yalnızca gerçek bağlantı
        // hatası (sunucuya hiç ulaşılamadı) düşer — bu zaten global interceptor'da (baglantiKesildi,
        // services/baglanti.js) ayrı bir tam ekran uyarıyla ele alınıyor. Burada "oturum bitti"
        // demek yanlış teşhis olur; token hâlâ yerelde geçerliyse geçişe izin ver, değilse
        // navigasyonu iptal et (bağlantı dönünce kullanıcı normal akışa döner).
        const token = depo.oku('token');
        const tokenExp = depo.oku('tokenExpiration');
        if (token && tokenExp && Date.now() < parseInt(tokenExp)) {
            return next();
        }
        return next(false);
    }
});

router.afterEach((to, from, failure) => {
    onaySifirla();
    // KDU: başka bir gezinme başarıyla bittiyse ekranda cevapsız kalan kirli onayı kapatılır.
    // Başarısız/iptal edilen gezinmede (failure) dokunulmaz — o an yeni bir soru açık olabilir.
    if (!failure) bekleyenOnayiKapat();
    uiState.navLoading = false;
    uiState.bootLoading = false;
    // NB planı tetikleyici 3: TTL doldu mu — AdminLayout'un watch'ı gerçek _GetNavbar() çağrısını yapar.
    if (!uiState.menuTazeleGerekli && menuTtlDoldu()) {
        uiState.menuTazeleGerekli = true;
    }
    // IZ-P: GA page_view (query'siz, parametreli rotada şablon) + oturum başına hesap_turu/paket.
    if (!failure) {
        olcum.sayfa(to);
        olcum.kullaniciOzellikGuncelle();
    }
});
router.onError((error, to) => {
    onaySifirla();
    uiState.navLoading = false;
    uiState.bootLoading = false;
    if (chunkHatasiMi(error)) yeniSurumUyarisiAc(to && to.fullPath);
});

export default router;